<div class="equipment-record">
  <h1 mat-dialog-title class="custom-dialog-title">
    Make Model Record
    <button mat-icon-button class="close-button" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div class="equipment-details modal-box">
    <h3>Make & Model</h3>
    <div class="equipment-field">
      <label><strong>Make:</strong></label>
      <span>{{ selectedOptions['make'] || data['make'] }}</span>
    </div>

    <div class="equipment-field">
      <label><strong>Model:</strong></label>
      <span>{{ selectedOptions['model'] || data['model'] }}</span>
    </div>

    <div class="equipment-field" *ngIf="this.pvcMakes.includes((this.selectedOptions['make'] != null ? this.selectedOptions['make'] : ''))">
      <label><strong>PVC:</strong></label>
      <span>{{ selectedOptions['pvc'] || data['pvc'] }}</span>
    </div>
  </div>

  <div class="available-resources modal-box">
    <h3>Available Resources</h3>
    <table class="resources-table" style="border-spacing: 0 20px; border-collapse: separate;">
      <thead>
      <tr>
        <th style="text-align: left;">MANUAL NAME</th>
      <th style="text-align: left;">
      <div
        class="manual-type-header"
        [matMenuTriggerFor]="manualTypeMenu"
        (click)="$event.stopPropagation()"
      >
        <span class="manual-type-label">
          MANUAL TYPE
        </span>
        <mat-icon class="manual-type-filter-icon">filter_alt</mat-icon>
      </div>
    </th>
        <th style="text-align: left;">SERIAL START</th>
        <th style="text-align: left;">SERIAL END</th>
        <th style="text-align: left;">PVC</th>
        <th style="text-align: left;">SERIAL EXCLUSIONS</th>
        <th style="text-align: left;"></th>
      </tr>
      </thead>
      <tbody>
        <tr *ngFor="let resource of filteredResources; let i = index" style="margin-bottom: 10px;">
          <td>
            {{ resource.file_name }}
          </td>
          <td>
            {{ resource.manualType || '—' }}
          </td>
          <td style="text-align: center;">
            {{ resource.serialStart || 'All' }}
          </td>
          <td style="text-align: center;">
            {{ resource.serialEnd || 'All' }}
          </td>
          <td style="text-align: center;">
            {{ resource.pvc ? (resource.pvc.replace('.0', '')) : '—' }}
          </td>
          <td style="text-align: center;">
            {{ resource.serialExclusions || '—' }}
          </td>
          <td>
            <div class="button-group">
              <button mat-button class="custom-view-button" (click)="openPDFModal(resource.url)">
                <mat-icon>visibility</mat-icon>
                View PDF
              </button>
              <button mat-icon-button class="custom-remove-button" (click)="removeResource(resource)">
                <mat-icon>delete</mat-icon>
                Remove
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top: 40px;">
      <button mat-raised-button color="accent" class="custom-switch-button" (click)="openUploadModal()" style="margin-top: 20px;"> 
      <mat-icon>upload</mat-icon>
      UPLOAD 
      </button>   
    </div>
    </div>
    <mat-menu #manualTypeMenu="matMenu" class="manual-type-menu">
    <div class="manual-type-menu-content" (click)="$event.stopPropagation()">

      <mat-form-field appearance="outline" class="manual-type-filter-field">
        <mat-label>Filter manual types</mat-label>

        <mat-select
          [formControl]="manualTypeFilter"
          multiple
          panelClass="manual-type-panel"
        >
          <ngx-mat-select-search
            [formControl]="manualTypeSearchCtrl"
            placeholderLabel="Search types"
            noEntriesFoundLabel="No matching types"
          ></ngx-mat-select-search>

          <mat-option *ngFor="let type of filteredManualTypeOptions" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-menu>

  <div class="common-prompts modal-box">
    <h3>Common Prompts</h3>
    <div *ngFor="let prompt of prompts; let i = index" class="prompt-item">
      <p>{{ prompt }}</p>
        <button *ngIf="prompts.length > 0" mat-icon-button class="button remove-button" (click)="removePrompt(i)">
          <mat-icon>delete</mat-icon>
          Remove
        </button>
    </div>
    <div *ngIf="isAdding" class="add-prompt-input">
      <input type="text" [(ngModel)]="newPrompt" placeholder="Enter new prompt" class="large-input">
      <button mat-raised-button color="primary" class="custom-save-button" (click)="saveNewPrompt()">
      <mat-icon>save</mat-icon>
        SAVE CHANGES
      </button>
    </div>
    <div *ngIf="!isAdding" class="add-prompt-container">
      <button mat-raised-button color="accent" class="custom-switch-button" (click)="addPrompt()">
        <mat-icon>add_circle_outline</mat-icon>
        ADD
      </button>
    </div>
    <div *ngIf="promptError != ''" class="prompt-error">
      <p>{{promptError}}</p>
    </div>
  </div>
</div>
